import React, { createContext, useState } from 'react';

interface Props {
  children: any;
}

export interface Context {
  open: boolean;
  setOpen: (open: boolean) => void | boolean;
  submenuIsOpen: boolean;
  setSubmenuIsOpen: (open: boolean) => void | boolean;
}

export const MenuContext = createContext<Context>({
  open: true,
  setOpen: () => {},
  submenuIsOpen: false,
  setSubmenuIsOpen: () => {},
});

export const MenuProvider: React.FC<Props> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(true);
  const [submenuIsOpen, setSubmenuIsOpen] = useState<boolean>(false);

  return (
    <MenuContext.Provider value={{ open, setOpen, submenuIsOpen, setSubmenuIsOpen }}>{children}</MenuContext.Provider>
  );
};
